import React, { useState } from 'react';
import { Icon } from 'components/ui/icon';
import SupportForm from 'services/support';
import { INACCURATE_TIPS_DATE_LABEL } from '../constants';

interface TipBannerProps {
  isDismissable?: boolean;
}

const TipBanner = ({ isDismissable = true }: TipBannerProps): JSX.Element => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return <></>;

  return (
    <div className="flex items-start gap-3 p-4 mb-5 rounded-md border border-warning-30 bg-warning-5">
      <div className="shrink-0 pt-0.5">
        <Icon
          name="info"
          size={20}
          className="text-warning-60"
          aria-hidden="true"
        />
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-between mb-1">
          <div className="text-sm font-medium text-gray-blue-90">
            Inaccurate Data
          </div>
          {isDismissable && (
            <button
              type="button"
              onClick={() => setDismissed(true)}
              aria-label="Dismiss banner"
              className="bg-transparent border-0 p-0 cursor-pointer text-gray-blue-60 hover:text-gray-blue-80"
            >
              <Icon name="x" size={16} aria-hidden="true" />
            </button>
          )}
        </div>
        <div className="text-sm text-gray-blue-70 leading-5">
          You have selected a date range that includes dates before{' '}
          <span className="font-medium text-gray-blue-90">
            {INACCURATE_TIPS_DATE_LABEL}
          </span>
          . Data for these dates may be inaccurate. Please adjust the date
          range. If you have any questions or encounter further issues, please{' '}
          <button
            type="button"
            onClick={SupportForm.openForm}
            className="text-dark-green-link bg-transparent border-0 p-0 cursor-pointer hover:opacity-80 underline"
          >
            Contact Support
          </button>
          .
        </div>
      </div>
    </div>
  );
};

export default TipBanner;
